import type { EscapeRoom } from '@/domain/escapeRoom'
import type { EscapeRoomRepository } from '@/repositories/EscapeRoomRepository'
import { seedEscapeRooms } from '@/data/seed/escapeRooms'

export class LocalEscapeRoomRepository implements EscapeRoomRepository {
  async list(): Promise<EscapeRoom[]> {
    return seedEscapeRooms
  }

  async getById(id: string): Promise<EscapeRoom | null> {
    return seedEscapeRooms.find((r) => r.id === id) ?? null
  }
}
